import { render, staticRenderFns } from "./VueCli.vue?vue&type=template&id=edf97408&scoped=true&"
import script from "./VueCli.vue?vue&type=script&lang=js&"
export * from "./VueCli.vue?vue&type=script&lang=js&"
import style0 from "./VueCli.vue?vue&type=style&index=0&id=edf97408&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf97408",
  null
  
)

export default component.exports